import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { SnackbarAlertsComponent } from '../../../app/shared/components/snackbar-alerts/snackbar-alerts.component';
import { SNACKBAR_ALERT_TYPES } from '../constants/snackbar-alert-types.enum';
import { TranslateService } from '../translate';

@Injectable({
    providedIn: 'root'
})
export class SnackbarAlertService {
    constructor(private snackBar: MatSnackBar, private translateService: TranslateService) {}

    getSnackbarAlertConfig(message: string, type: SNACKBAR_ALERT_TYPES) {
        let config = new MatSnackBarConfig();
        config.duration = 7000;
        config.horizontalPosition = 'start';
        config.verticalPosition = 'bottom';
        config.data = {
            message: message,
            type: type
        };
        return config;
    }

    openSnackBar(message: string, type: SNACKBAR_ALERT_TYPES) {
        const msg = this.translateService.instant(message);
        const config = this.getSnackbarAlertConfig(msg, type);
        this.snackBar.openFromComponent(SnackbarAlertsComponent, config);
    }
}
